import { JetView } from 'webix-jet';
import { profile } from 'config/config';

/**
 * FilterAgentListView class extends JetView to create a filter form for agents.
 */
export default class FilterAgentListView extends JetView {
    /**
     * Configures the layout of the filter form.
     * @returns {Object} The configuration object for the form.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section with partner selection
        const left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'richselect',
                    name: 'Partner',
                    label: _('Partner'), // Label for the partner selection
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: profile.Partners, // Options from profile configuration
                    id: 'Partners', // Unique ID for the component
                },
            ],
        };

        // Center left section with country selection
        const center_left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'richselect',
                    name: 'Country',
                    localId: 'regions:combo', // Local ID for the component
                    label: "<span class='icon-language'></span>" + _('País'), // Label with icon
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [], // Initially empty options
                    id: 'Countries', // Unique ID for the component
                },
            ],
        };

        // Center right section (currently empty)
        const center_right = {
            margin: 5,
            minWidth: 200,
            rows: [],
        };

        // Right section (currently empty)
        const right = {
            margin: 5,
            minWidth: 200,
            rows: [],
        };

        // Upper section containing left and center left components
        const upper_section = {
            id: 'a1',
            rows: [
                {
                    responsive: 'a1',
                    margin: 10,
                    cols: [left, center_left],
                },
            ],
        };

        // Button section with a consult button
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        {
                            view: 'button',
                            value: _('Consultar'), // Button label
                            hotkey: 'enter', // Hotkey for the button
                            type: 'form', // Button type
                            minWidth: 200,
                            click: () => {
                                $$('formSettingsPartner').show(); // Show partner settings form
                                const filterdata = this.getRoot().getValues(); // Get form values
                                this.app.callEvent('partnerSettings:filter', [filterdata]); // Trigger filter event
                            },
                        },
                    ],
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form',
            id: 'formFilter', // Unique ID for the form
            rows: [upper_section, buttons], // Form layout
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for the form
            },
        };
    }

    /**
     * Initializes event listeners for the form components.
     */
    init() {
        var vthis = this; // Reference to the current instance

        // Event listener for partner selection change
        $$('Partners').attachEvent('onChange', function (newv) {
            $$('formSettingsPartner').show(); // Show partner settings form
            $$('Countries').define(
                'options',
                $$('Partners').getList().getItem(newv).Countries, // Update country options based on selected partner
            );
            $$('Countries').define(
                'value',
                $$('Partners').getList().getItem(newv).Countries[0], // Set default country value
            );
            $$('Countries').refresh(); // Refresh the country dropdown
            const filterdata = $$('formFilter').getValues(); // Get current filter values
            console.log('Filtro Partner', filterdata); // Log filter data
            vthis.app.callEvent('partnerSettings:filter', [filterdata]); // Trigger filter event
        });

        // Event listener for country selection change
        $$('Countries').attachEvent('onChange', function (newv) {
            $$('formSettingsPartner').show(); // Show partner settings form
            const filterdata = $$('formFilter').getValues(); // Get current filter values
            console.log('Filtro Partner', filterdata); // Log filter data
            vthis.app.callEvent('partnerSettings:filter', [filterdata]); // Trigger filter event
        });
    }
}

// FILE DOCUMENTED
